module.exports = __webpack_public_path__ + "static/media/AC-poptart.2a98e852.jpg";